"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSliderSizes = exports.getUrl = exports.getFade = exports.getMimeType = exports.timeToString = exports.timeToPercentage = void 0;
var getTime = function (n) {
    var seconds = !Number.isFinite(n) ? 0 : Math.trunc(n);
    var dateString = new Date(seconds * 1000).toISOString();
    return seconds >= 3600 ? dateString.substr(11, 8) : dateString.substr(14, 5);
};
var timeToPercentage = function (time) { return time ? (time.currentTime / time.duration) * 100 : 0; };
exports.timeToPercentage = timeToPercentage;
var timeToString = function (time) { return getTime(time.currentTime) + "/" + getTime(time.duration); };
exports.timeToString = timeToString;
var getMimeType = function (url) {
    var mimeMap = {
        mid: 'audio/midi',
        midi: 'audio/midi',
        kar: 'audio/midi',
        mp3: 'audio/mpeg',
        ogg: 'audio/ogg',
        ra: 'audio/x-realaudio',
        '3gpp': 'video/3gpp',
        '3gp': 'video/3gpp',
        mpeg: 'video/mpeg',
        mpg: 'video/mpeg',
        mov: 'video/quicktime',
        flv: 'video/x-flv',
        mng: 'video/x-mng',
        asx: 'video/x-ms-asf',
        asf: 'video/x-ms-asf',
        wmv: 'video/x-ms-wmv',
        avi: 'video/x-msvideo',
        m4v: 'video/mp4',
        mp4: 'video/mp4',
    };
    return mimeMap[url.split(/[#?]/)[0].split('.').pop().trim()];
};
exports.getMimeType = getMimeType;
var getFade = function (settings, duration, currentTime) {
    if (!settings)
        return 1;
    var fadeOut = duration - currentTime;
    if (fadeOut <= settings.fadeOutTime) {
        return fadeOut / settings.fadeOutTime;
    }
    if (currentTime <= settings.fadeInTime) {
        return currentTime / settings.fadeInTime;
    }
    return 1;
};
exports.getFade = getFade;
var getUrl = function (src) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(typeof src === 'function')) return [3 /*break*/, 2];
                return [4 /*yield*/, src()];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [4 /*yield*/, src];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getUrl = getUrl;
var lineThick = {
    'thin': 5,
    'medium': 10,
    'large': 15
};
var lineMargin = {
    'thin': -1,
    'medium': -4,
    'large': -6
};
var thumbThick = {
    'thin': 15,
    'medium': 20,
    'large': 25
};
var getSliderSizes = function (thickness, others) {
    return ({
        thumb: __assign({ width: thumbThick[thickness || 'thin'], height: thumbThick[thickness || 'thin'], marginTop: lineMargin[thickness || 'thin'] - 5 }, others.thumb),
        rail: __assign({ height: lineThick[thickness || 'thin'], marginTop: lineMargin[thickness || 'thin'], borderRadius: lineThick[thickness || 'thin'] }, others.rail),
        track: __assign({ height: lineThick[thickness || 'thin'], marginTop: lineMargin[thickness || 'thin'], borderRadius: lineThick[thickness || 'thin'] }, others.track)
    });
};
exports.getSliderSizes = getSliderSizes;
//# sourceMappingURL=utils.js.map